<div class="hd-shell" *ngIf="!loader; else loadingTpl">
  <div class="hd-header-area">
    <div class="hd-title-wrap">
      <div class="hd-title-icon">
        <i class="pi pi-home"></i>
      </div>
      <div>
        <h1 class="hd-title">Hello, {{ username }}</h1>
        <p class="hd-subtitle">{{ companyName }}</p>
      </div>
    </div>

    <div class="hd-header-actions">
      <div class="hd-date-chip">
        <i class="pi pi-calendar"></i>
        {{ todayDate }}
      </div>
      <button class="hd-btn hd-btn-primary" (click)="refreshData()">
        <i class="pi pi-sync"></i> Refresh
      </button>
    </div>
  </div>

  <p-tabView styleClass="hd-tabs">
    <p-tabPanel header="Dashboard">
      <div class="hd-kpi-row">
        <div class="hd-kpi-card hd-kpi-blue cursor-pointer" [routerLink]="['/home/listInvoice']">
          <span class="hd-kpi-label">Invoices</span>
          <div class="hd-kpi-val" id="invoiceNumber">{{ invoice }}</div>
          <span class="hd-kpi-foot">Last Month Invoices</span>
          <i class="pi pi-file-edit hd-kpi-icon"></i>
        </div>

        <div class="hd-kpi-card hd-kpi-teal">
          <span class="hd-kpi-label">Customers</span>
          <div class="hd-kpi-val" id="customerNumber">{{ customer }}</div>
          <span class="hd-kpi-foot">Total Customers</span>
          <i class="pi pi-users hd-kpi-icon"></i>
        </div>

        <div class="hd-kpi-card hd-kpi-amber" [routerLink]="['/home/listvendors']">
          <span class="hd-kpi-label">Vendor</span>
          <div class="hd-kpi-val" id="vendorNumber">{{ vendor }}</div>
          <span class="hd-kpi-foot">Total Vendors</span>
          <i class="pi pi-building hd-kpi-icon"></i>
          <span class="hd-live-dot"></span>
        </div>

        <div class="hd-kpi-card hd-kpi-rose" [routerLink]="['/home/listsalesPerson']">
          <span class="hd-kpi-label">Salesperson</span>
          <div class="hd-kpi-val" id="salespersonNumber">{{ salesperson }}</div>
          <span class="hd-kpi-foot">Total Salespersons</span>
          <i class="pi pi-user hd-kpi-icon"></i>
          <span class="hd-live-dot"></span>
        </div>
      </div>

      <div class="hd-alert-grid">
        <div class="hd-alert-panel">
          <h3 class="hd-alert-title">Attention Required</h3>

          <div class="hd-alert-list">
            <div class="hd-alert-item">
              <span class="hd-alert-count danger">{{ attentionBillsOverdue }}</span>
              <p><strong>Bills</strong> have crossed their due dates</p>
            </div>

            <div class="hd-alert-item">
              <span class="hd-alert-count warning">{{ attentionBillsDueToday }}</span>
              <p><strong>Bills</strong> are to be paid by today</p>
            </div>

            <div class="hd-alert-item">
              <span class="hd-alert-count danger">{{ attentionInvoicesOverdue }}</span>
              <p><strong>Invoices</strong> have crossed their due dates</p>
            </div>
          </div>
        </div>

        <div class="hd-alert-panel">
          <h3 class="hd-alert-title">Pending Actions</h3>

          <div class="hd-alert-list">
            <div class="hd-alert-item">
              <span class="hd-alert-count warning">{{ pendingPurchaseOrders }}</span>
              <p><strong>Purchase Orders</strong> are pending for approval</p>
            </div>

            <div class="hd-alert-item">
              <span class="hd-alert-count warning">{{ pendingSalesOrders }}</span>
              <p><strong>Sales Orders</strong> are yet to be processed</p>
            </div>

            <div class="hd-alert-item">
              <span class="hd-alert-count danger">{{ pendingPayments }}</span>
              <p><strong>Payments</strong> are pending confirmation</p>
            </div>

            <div class="hd-alert-item">
              <span class="hd-alert-count warning">{{ pendingMaterialRequests }}</span>
              <p><strong>Material Requests</strong> are yet to be processed</p>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>

    <p-tabPanel header="Announcement">
      <div class="hd-list-panel">
        <h3 class="hd-list-title">Announcements</h3>
        <div class="hd-animated-list">
          <div class="hd-list-item">
            <i class="pi pi-megaphone"></i>
            <div>
              <h4>Product Notifications</h4>
              <p>Important announcements will appear here for all users.</p>
            </div>
          </div>
          <div class="hd-list-item">
            <i class="pi pi-shield"></i>
            <div>
              <h4>System Maintenance</h4>
              <p>Any planned maintenance windows and impact notes will be shown here.</p>
            </div>
          </div>
          <div class="hd-list-item">
            <i class="pi pi-users"></i>
            <div>
              <h4>Team Broadcasts</h4>
              <p>Cross-team communication updates and release notes are listed in this section.</p>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>

    <p-tabPanel header="Recent Updates">
      <div class="hd-list-panel">
        <h3 class="hd-list-title">Mapsoft ERP | Recent Updates</h3>
        <div class="hd-animated-list">
          <div class="hd-list-item">
            <i class="pi pi-check-circle"></i>
            <div>
              <p>Invoice details can now be updated directly.</p>
            </div>
          </div>
          <div class="hd-list-item">
            <i class="pi pi-cog"></i>
            <div>
              <p>Department and Unit labels can now be renamed via system settings.</p>
            </div>
          </div>
          <div class="hd-list-item">
            <i class="pi pi-file"></i>
            <div>
              <p>Form download now sanitizes transaction numbers for safe file naming.</p>
            </div>
          </div>
          <div class="hd-list-item">
            <i class="pi pi-box"></i>
            <div>
              <p>Improved product UI with enhanced hierarchy view.</p>
            </div>
          </div>
          <div class="hd-list-item">
            <i class="pi pi-shopping-cart"></i>
            <div>
              <p>Purchase Orders can now be raised directly from Product Requisition.</p>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>

    <p-tabPanel header="Getting Started">
      <div class="hd-list-panel">
        <h3 class="hd-list-title">Quick Start</h3>
        <div class="hd-animated-list">
          <div class="hd-list-item">
            <i class="pi pi-arrow-right"></i>
            <div>
              <p>Create customers and vendors first to start transaction flow.</p>
            </div>
          </div>
          <div class="hd-list-item">
            <i class="pi pi-arrow-right"></i>
            <div>
              <p>Use Sales Orders and Purchase Orders from the left menu to begin operations.</p>
            </div>
          </div>
          <div class="hd-list-item">
            <i class="pi pi-arrow-right"></i>
            <div>
              <p>Track performance from dashboard cards and recent transaction panels.</p>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>

<ng-template #loadingTpl>
  <div class="hd-loader">
    <div class="hd-loader-ring"></div>
    <p>Loading Home Dashboard...</p>
  </div>
</ng-template>